export default __webpack_public_path__ + "static/media/site_icon.ba895ac0.svg";